import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { loadCachedContent } from "@/world/content";

// Repeat visitors see the last known content immediately; App then refreshes it in the background.
loadCachedContent();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
